
import {
  USERS_REQUEST,
  USERS_RESPONSE,
  USERS_FAIL
} from './types';



export const usersRequest = () => {
  return {
    type: USERS_REQUEST
  };
}

export const usersResponse = (payload) => {
  return {
    type: USERS_RESPONSE,
    payload: payload
  };
}

export const usersFail = (err) => {
  return {
    type: USERS_FAIL
  };
}




// export function fetchTasksWithRedux() {
//     return (dispatch) => {
//         dispatch(usersRequest());
//         return axios
//            .post('http://intranet.localhost.com/api/task/all')
//            .then(res => dispatch(usersResponse(res.data)))
//            .catch(err => dispatch(usersFail(err)));
//     }
// }



// WEBPACK FOOTER //
// ./src/Actions/UserActions.js